// extracted by mini-css-extract-plugin
export default {"cta":"gI-z","disabled":"hI-z"};